import request from "./request";
import { apiRequest } from "./apirequest";



export const getCountryList = () => apiRequest({ endpoint: "/admin/settings/countries" });
export const getStateList = (countryID) => apiRequest({ endpoint: `/admin/settings/states/${countryID}` });
export const getCityList = (stateID) => {
    console.log("State ID:", stateID); // Console log the stateID
    return apiRequest({ endpoint: `/admin/settings/cities/${stateID}` });
};
export const getCorporateList  = () => apiRequest({ endpoint: "/web/corporate" });
export const getProductList = (ArrayLength, ProductID) => {
    // Log the length to the console
    console.log("Array++++++ Length:", ArrayLength);
  // Set isCombo based on ArrayLength
const isComboValue = ArrayLength;

// Start building the URL
let url = `/web/product?isCombo=${isComboValue}&status=Active`;
if(ProductID) {
  url = `/web/product?isCombo=${isComboValue}&combo_product_id=${ProductID}&status=Active`;
}
// Add antenna=true to the URL if isCombo is true
if (isComboValue) {
  url += "&antenna=true";
}

// Make the API request with the dynamically constructed URL
return apiRequest({
  endpoint: url,
});
};
  
export const fetchOtpVerificationApi = (data) => apiRequest({ endpoint: "/web/user/otp-verify",method: "PUT", data: data });
export const getUserInfo = (userID) => {
  return apiRequest({
    endpoint: userID ? `/web/user/user-info/${userID}` : "/web/user/user-info"
  });
};

export const getOrderDetails =  (orderId) => apiRequest({endpoint: `/web/order/details/${orderId}`});
export const getOrderTrackingDetails =  (orderId) => apiRequest({endpoint: `/web/order/tracking-shipment/${orderId}`});
export const  getHelpList = () => apiRequest({endpoint: "web/setting/help"});
 export const ProfileUpdateOtpRequest = (mobile) => apiRequest({endpoint: "/web/user/auth/send-mobile-otp", method : "POST", data:{"mobile": mobile} });
export const  profileOtpConfirm =  (data) => apiRequest({endpoint : "/web/user/mobile-otp-verify", method: "PUT", data:data})

